import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { Platform, StyleSheet, TouchableWithoutFeedback, View } from 'react-native';
import color from 'color';
import configureFonts from "../styles/fonts";
import PnmacText from '../Typography/PnmacText';
import { white } from '../styles/colors';
var fonts = configureFonts();
/**
 * A component used to display a title and optional subtitle in a appbar.
 */
var AppbarContent = /** @class */function (_super) {
  __extends(AppbarContent, _super);
  function AppbarContent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AppbarContent.prototype.render = function () {
    var _a = this.props,
      _b = _a.color,
      titleColor = _b === void 0 ? white : _b,
      subtitle = _a.subtitle,
      subtitleStyle = _a.subtitleStyle,
      onPress = _a.onPress,
      style = _a.style,
      titleRef = _a.titleRef,
      titleStyle = _a.titleStyle,
      title = _a.title,
      rest = __rest(_a, ["color", "subtitle", "subtitleStyle", "onPress", "style", "titleRef", "titleStyle", "title"]);
    var subtitleColor = color(titleColor).alpha(0.7).rgb().string();
    return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
      onPress: onPress,
      disabled: !onPress
    }, /*#__PURE__*/React.createElement(View, __assign({
      style: [styles.container, style]
    }, rest), /*#__PURE__*/React.createElement(PnmacText, {
      ref: titleRef,
      style: [__assign({
        color: titleColor
      }, Platform.OS === 'ios' ? fonts.regular : fonts.medium), styles.title, titleStyle],
      numberOfLines: 1,
      accessible: true,
      accessibilityTraits: "header",
      // @ts-ignore
      accessibilityRole: Platform.OS === 'web' ? 'heading' : 'header'
    }, title), subtitle ? (/*#__PURE__*/React.createElement(PnmacText, {
      style: [styles.subtitle, {
        color: subtitleColor
      }, subtitleStyle],
      numberOfLines: 1
    }, subtitle)) : null));
  };
  AppbarContent.displayName = 'Appbar.Content';
  return AppbarContent;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 12
  },
  title: {
    fontSize: Platform.OS === 'ios' ? 17 : 20
  },
  subtitle: {
    fontSize: Platform.OS === 'ios' ? 11 : 14
  }
});
export default AppbarContent;
export { AppbarContent };